import React, { useEffect, useState, lazy } from "react";
import { Link, useNavigate } from "react-router-dom";
import Menu from "../../icons/Menu";
import Tabmenu from "../tabmenu/Tabmenu";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { ScheduleCard } from "../consultant/scheduleCard";
import {  getConsumerDetail, getVitals, getVitalsReference, uploadDocument } from "../../lib/api";
import { Spinner } from "../../shared/svgIcon";
import { useStore } from "../../store";
import { useAppointmentsMiscellaneous } from "../../shared/utils";
import ECGGraph from "../echGraph/EcgGraph";
import VitalGraph from "../VitalGraph";
import { useQuery } from "@tanstack/react-query";



export default function Dashboard() {
  let navigate = useNavigate();
  const [dataset, setDataset] = useState([]);
  // const [isKiosk, setKiosk] = useState(false);
  const [vitalData, setVitalData] = useState(null);
  const [ecgData, setEcgData] = useState(null);
  const [files, setFiles] = useState([]);
  const [isEcgAdded, setEcgAdded] = useState(false);
  const [uploadmodel, setUploadmodel] = useState(false);

  const [filetype, setfiletype] = useState("");
  const [doctype, setDoctype] = useState("");
  const [file, setFile] = useState(null);
  const [fileuploading, setFileuploading] = useState("false");

  const setPatient = useStore(state => state.setPatient)
  const setVital = useStore(state => state.setCurrentVitals)
  const setEcg = useStore(state => state.setCurrentEcg)
  const { data: appointmentsMisc } = useAppointmentsMiscellaneous();
  const [filetypes, setfiletypes] = useState( []);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [vitalArray, setVitalArray] = useState([]);

  useEffect(() => {
    if(appointmentsMisc){
      setfiletypes( appointmentsMisc?.data?.result?.document_file_types || [])
      setDocumentTypes( appointmentsMisc?.data?.result?.document_types || [])
    }
  }, [appointmentsMisc])
  
  useEffect(() => {
    if (filetypes?.length > 0 ) {
      setfiletype(filetypes[0].value)
    }
  }, [filetypes]);
  useEffect(() => {
    if (documentTypes?.length > 0 ) {
      setDoctype(documentTypes[0].value)
    }
  }, [documentTypes]);
  const handleFileChange = (e) => {
    console.log(e);
    setFile(e.target.files[0]);
    console.log(e.target.files[0]);
  };
  const documentupload = async () => {
    setFileuploading("true");
    const formData = new FormData();
    if (doctype != null && filetype != null) {
      var id = localStorage.getItem("patientId");
      formData.append("consumer_id", id);
      formData.append("file", file);
      formData.append("upload_type", "aws_s3");
      formData.append("doc_type", doctype);
      formData.append("file_type", filetype);
      formData.append(
        "source",
        JSON.stringify({
          identifier: "654cc54350349ba664618567",
          classification: "kiosk",
          location: "trivandrum",
          name: "lulu",
        })
      );

      // console.log(formData);
      const res = await uploadDocument(formData);
      if (res?.message == "successfully completed") {
        if (res?.data?.result?.inference_details?.image) {
          sessionStorage.removeItem("currentEcg");
          navigate("/ecgView");
        }
        setUploadmodel(false);
        setFileuploading("false");
      } else {
        setFileuploading("false");
      }
    } else {
      setFileuploading("Select all options");
    }
  };

  const settings = {
    // dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    if (localStorage.getItem("patientId")) {
      async function fetchData() {
        try {
          const res = await fetchPatient(localStorage.getItem("patientId"));
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
  
      fetchData();
      
      
    }
    // getVitalInfo();
  }, []);


  const fetchPatient = async (id) => {
    const res = await getConsumerDetail(id);
    // console.log(res.data?.result, "consumer");
    if (res?.data?.result?.consumer_details) {
      setPatient(res?.data?.result?.consumer_details)
      setDataset(res?.data?.result?.consumer_details);
      //fix dynamic patientdata
      // sessionStorage.setItem(
      //   "patientdata",
      //   JSON.stringify({ ...res?.data?.result?.consumer_details })
      // );
      const patientPhone = res?.data?.result?.consumer_details?.contact?.find(
        (e) => e.type == "phone"
      )?.value;
      // console.log(patientPhone, "contact");
      if (patientPhone) sessionStorage.setItem("patientPhone", patientPhone);
    }
    const ecgRes = res?.data?.result?.ecg;
    if (ecgRes) {
      const ecgDetails = ecgRes?.[ecgRes?.length - 1];
      if (ecgRes?.[ecgRes?.length - 1]) {
        setEcgData(ecgDetails);
        setEcg(ecgDetails)
        sessionStorage.setItem("currentEcg", JSON.stringify(ecgDetails));
      }
    }
    const vitalRes = res?.data?.result?.vitals;
    if (vitalRes) {
      const vitalDetails = vitalRes?.[vitalRes?.length - 1];
      if (vitalDetails) {
        setVitalData(vitalDetails?.data);
        setVital(vitalDetails)
        sessionStorage.setItem("currentVitals", JSON.stringify(vitalDetails));
      }
    }
  };

  const getVitalInfo = async () => {
    const patientId = localStorage.getItem("patientId");
    if (!patientId) return;
    const vitalSession = sessionStorage.getItem("currentVitals")
      ? JSON.parse(sessionStorage.getItem("currentVitals"))
      : null;
    if (vitalSession) {
      setVitalData(vitalSession?.data);
      return;
    }

    const res = await getVitals({patientId});
    const result = res?.data?.result;
    const vitalDetails = result?.[result?.length - 1]?.data;
    setVitalData(vitalDetails);
    if (result?.[result?.length - 1])
      sessionStorage.setItem(
        "currentVitals",
        JSON.stringify(result?.[result?.length - 1])
      );
    // console.log(vitalDetails, "vit");
  };

  const { data, isLoading: vitalLoading } = useQuery({
    queryKey: ["vitalRef"],
    queryFn: () => getVitalsReference(),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const vitalInfos = data?.data?.result;

  const updateVitalList = () => {
    const mergedArray = Object.entries(vitalData)
    .filter(([key, value]) => value && value.value !== null)
    .map(([key, measurement]) => {
      const vitalInfo = vitalInfos.find(
        (info) => info.abbreviation.toLowerCase() === key.toLowerCase()
      );
      if (vitalInfo) {
        const { unit, value } = measurement;
        return { ...measurement, ...vitalInfo };
      }
    });
  mergedArray?.sort((a, b) => a.display_order - b.display_order);
  const vitalList = mergedArray.slice(0, 3);
  setVitalArray(vitalList );
  // console.log(vitalList,'vitalList')
  }

  useEffect(() => {
    if (!vitalData || !vitalInfos) return;
    updateVitalList()
  }, [vitalData, vitalInfos]);

  return (
    <>
      <div className="bg-primary">
        <div className="flex text-black p-4 pt-6 h-24 fixed bg-gray-100 max-w  z-50 w-full">
          <div>
            {dataset?.profile?.avatar_url ? (
              <img
                src={dataset?.profile?.avatar_url}
                className=" mx-2 rounded-full object-cover h-14 w-14 -mt-2"
                alt="avatar"
              />
            ) : (
              <img
                src="../../../images/user.svg"
                className=" mx-2 rounded-full object-cover h-14 w-14 -mt-2"
                alt="user"
              />
            )}
          </div>
          <div className="mt-1 flex-1">
            <h4 className="font-bold">
              {" "}
              <>
                {dataset?.profile?.first_name
                  ? dataset?.profile?.first_name +
                    " " +
                    dataset?.profile?.middle_name +
                    " " +
                    dataset?.profile?.last_name
                  : " "}
              </>
            </h4>
            <h6 className="text-xs">
              {dataset?.age ? dataset?.age + " Years old" : ""}
            </h6>
          </div>
          <div className="pt-3 pr-2">
            <button className="">
              <img
                src="../../../images/bell.svg"
                className=" mx-2 rounded-full"
                alt="bell"
              />
            </button>
          </div>
          <div className="pt-1">
            <button className="bg-blue-200 pl-2 pr-3 h-10 w-10 rounded-full">
              <Menu height={13} />
            </button>
          </div>
        </div>
        <div className="h-24"></div>
        <div className="bg-gray-100 rounded-b-3xl overflow-hidden">
          <Slider {...settings} >
            {!vitalData ? (
              <div
                className={`text-primary-800 p-2 relative overflow-hidden  rounded-b-3xl bg-slate-50 h-80`}
              >
                <div className="">
                  <img
                    src="../../../images/slide1.png"
                    alt="slide"
                    className=" absolute bottom-0 right-0"
                  />
                  <div className="relative z-20 pb-28">
                    <div className="text-3xl pt-5 font-semibold">
                      How are you <br />
                      feeling today?
                    </div>
                    {/* <button className="bg-primary flex py-2 pl-2 pr-4 rounded-full text-white mt-4">
                      <img
                        src="../../../images/condetionbtn.svg"
                        alt="slide"
                        className=" mx-2 mt-1 rounded-full"
                      />{" "}
                      Add condition
                    </button> */}
                  </div>
                </div>
              </div>
            ) : (
              <div
                className={`text-primary-800 px-4 relative overflow-hidden  rounded-3xl bg-white h-80`}
              >
                <div className="">
                  <div className="text-lg font-semibold text-gray-800 py-2">
                    Vital Signs Monitor
                  </div>
                  <div className="flex bg-gray-100 text-sm font-medium mt-1 text-black p-2.5 px-4 rounded-full">
                    <div className="border-r flex-1 ">
                      Name :{" "}
                      {dataset?.profile?.first_name
                        ? (
                            dataset?.profile?.first_name +
                            " " +
                            dataset?.profile?.middle_name +
                            " " +
                            dataset?.profile?.last_name
                          ).slice(0, 7)
                        : ""}
                    </div>
                    {/* <div className='px-2 border-r'>ID: 345246  </div> */}
                    <div className="flex-1 text-right">
                      {dataset?.dob ? dataset?.dob : ""}
                    </div>
                  </div>
                  <div className="border  bg-red-100 font-medium shadow-sm mt-3 text-lg text-gray-600 p-2 px-4 mb-2 rounded-full">
                    <div className="flex ">
                      <div className="flex-1 pt-1">SBP</div>
                      <div className="text-red-500 text-3xl  font-semibold text-center">
                        {vitalData?.sbp?.value ? vitalData?.sbp?.value : "-"}/
                        {vitalData?.dbp?.value ? vitalData?.dbp?.value : "-"}
                      </div>
                      <div className="flex-1 text-right  pt-1">DBP</div>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <div className="border  bg-yellow-100 shadow-sm  text-black p-2 px-4 my-2 rounded-full flex-1 grid grid-cols-3">
                      <div className="pt-1.5">Sp02</div>
                      <div className="text-3xl text-yellow-500 font-semibold text-center">
                        {vitalData?.spo2?.value ? vitalData?.spo2?.value : "-"}
                      </div>
                      <div className="text-right pt-1.5">%</div>
                    </div>
                    <div className="border  bg-yellow-100 shadow-sm   text-black p-2 px-4 my-2 rounded-full flex-1 grid grid-cols-3">
                      <div className="pt-1.5">Pulse</div>
                      <div className="text-3xl text-yellow-500 font-semibold text-center">
                        {vitalData?.hr?.value ? vitalData?.hr?.value : "-"}
                      </div>
                      <div className="text-right pt-1.5"></div>
                    </div>
                  </div>
                  <div className="flex gap-2 mb-3">
                    <div className="border  bg-blue-100 shadow-sm   text-black p-2 px-4 my-2 rounded-full flex-grow sm:flex-1 grid grid-cols-3">
                      <div className="pt-1.5">RR</div>
                      <div className="text-3xl text-blue-500 font-semibold  text-center">
                        {vitalData?.rr?.value ? vitalData?.rr?.value : "-"}
                      </div>
                      <div className="text-right pt-1.5"></div>
                    </div>
                    <div className="border  bg-green-100 shadow-sm  text-black p-2 px-4 my-2 rounded-full flex-grow sm:flex-1 grid grid-cols-3">
                      <div className="pt-1.5 col-span-2 sm:col-span-1 flex-1">
                        Temperature
                      </div>
                      <div className="grid grid-cols-2 sm:col-span-2">
                        <div className="text-3xl text-green-500 font-semibold text-center">
                          {vitalData?.temperature?.value
                            ? vitalData?.temperature?.value
                            : "-"}
                        </div>
                        <div className="text-right pt-1.5">°{vitalData?.temperature?.unit || 'C'}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {ecgData && (
              <div
                className={`text-primary-800 p-1 relative overflow-hidden  rounded-3xl bg-white h-80`}
              >
                <div className="bg-white flex flex-col relative">
                  <img
                    src={`data:image/jpeg;base64,${ecgData?.inference?.image_stream}`}
                    alt="ecg"
                    className="object-contain h-[170px]"
                  />
                  <div className="flex mb-4">
                    <div className="text-right font-bold text-5xl flex-1 leading-none">
                      {" "}
                      {ecgData?.inference?.extras?.heart_rate?.split(" ")[0]}
                    </div>
                    <span className="text-gray-700 font-semibold text-base pb-2  flex leading-none items-end">
                      {ecgData?.inference?.extras?.heart_rate?.split(" ")[1]}
                    </span>
                    <div className="flex-1 text-red-700  flex items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="red"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-7 h-7"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
                        />
                      </svg>
                      {/* <span className='text-gray-700'>Time/min</span>  */}
                    </div>
                  </div>
                  <div className="flex px-2 text-center">
                    <div className="flex-1">
                      <b className="text-2xl">
                        {ecgData?.inference?.extras?.mains_frequency || "-"}
                      </b>
                      <br /> MF{" "}
                    </div>
                    <div className="flex-1">
                      <b className="text-2xl">
                        {ecgData?.inference?.extras?.scale_mm_per_mV || "-"}
                      </b>
                      <br /> mm/mv{" "}
                    </div>
                    <div className="flex-1">
                      <b className="text-2xl">
                        {ecgData?.inference?.extras?.scale_mm_per_s || "-"}
                      </b>
                      <br /> mm/s{" "}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {
              ecgData &&<div
              className={`text-primary-800 px-4 relative overflow-hidden  rounded-3xl bg-white h-80 `}
            > <ECGGraph ecgData={ecgData}/> </div>
            }
            {
              vitalData &&  vitalArray.map((vital, index) => {
                if (vital?.display_name) {
                  return (
                    <div key={index}
                className={`text-primary-800 px-4 relative overflow-hidden  rounded-3xl bg-white h-80`}
              >
<VitalGraph vitalData ={vital} />
              </div>
                    
                  );
                } else {
                  return null;
                }
              })
            }
          </Slider>
        </div>
        <div className="p-4 ">
          <div className="grid grid-cols-6 gap-4">
            {/* <div className='bg-green-200 p-4 rounded-3xl relative col-span-3'>
              <img src="../../../images/tabicon.png" className=" absolute bottom-0 right-0 z-0"/>
              <div className='text-lg font-bold leading-5 mb-2'>Add <br/>Medication</div>
              <p className='leading-4 text-xs mb-8'>Did you add <br/>your medicine <br/>today</p>
              <Link to="/addMedication"  className='relative z-40 rounded-full px-3 py-1 bg-white text-black text-sm font-semibold mt-10 inline-block'>Add</Link>
            </div> */}
            <div className="bg-green-200 p-4 rounded-3xl overflow-hidden relative col-span-3">
              <img
                src="../../../images/checkvitalsl.png"
                className=" absolute bottom-0 right-0 z-0 "
                alt="checkvitalsl"
              />
              <div className="text-lg font-bold leading-5 mb-2 z-10">
                Check <br />
                Vitals
              </div>
              <p className="leading-4 text-xs mb-8 z-40">
                Did you check <br />
                your vitals <br />
                today?
              </p>
              <Link
                to="/addVitals"
                className="relative z-40 rounded-full px-3 py-1 bg-white text-black text-sm font-semibold mt-10 inline-block"
              >
                Add
              </Link>
            </div>
            <div className="bg-indigo-200 p-4 rounded-3xl relative col-span-3">
              <img
                src="../../../images/bloodpresure.png"
                className=" absolute bottom-0 right-0"
                alt="bloodpresure"
              />
              <div className="text-lg font-bold leading-5 mb-2">ECG</div>
              {ecgData ? (
                <p className="leading-4 text-xs mb-8">
                  View
                  <br /> My ECG.{" "}
                </p>
              ) : (
                <p className="leading-4 text-xs mb-8">
                  Add
                  <br /> Your ECG <br />
                  Report <br /> Here.
                </p>
              )}
              {ecgData ? (
                <Link
                  to="/documentHistory?type=ecg"
                  className=" rounded-full px-3 py-1 bg-white text-black text-sm font-semibold mt-10 inline-block absolute bottom-[1rem]"
                >
                  View
                </Link>
              ) : (
                <div
                  onClick={() => setUploadmodel(!uploadmodel)}
                  htmlFor="dropzone-file"
                  className="rounded-full px-3 py-1 bg-white text-black text-sm font-semibold mt-10 inline-block absolute bottom-[1rem]"
                >
                  <p className="leading-4 text-xs">Upload</p>
                </div>
              )}
            </div>

            <div className="bg-orange-50 p-4 rounded-3xl col-span-6 relative">
              <img
                src="../../../images/symptoms.png"
                className=" absolute bottom-0 right-0"
                alt="symptoms"
              />
              <div className="text-lg font-bold leading-5 mb-2">
                Check
                <br />
                Symptoms
              </div>
              <p className="leading-4 text-xs">
                Find a possible diagnosis for <br />
                your health issue
              </p>
              <Link
                to="/CheckSymptoms"
                className=" rounded-full px-3 py-1 bg-primary text-white text-sm font-semibold mt-10 inline-block"
              >
                Check symptoms
              </Link>
            </div>
            <div className="bg-[#eedbac] p-4 rounded-3xl col-span-6 relative">
              <img
                src="../../../images/facility.png"
                className=" absolute bottom-0 right-0"
                alt="facility"
              />
              <div className="text-lg font-bold leading-5 mb-2">
                Add 
                <br />
                Facilities
              </div>
              <p className="leading-4 text-xs">
                Add your Hospital or  <br />
                Facilities here
              </p>
              <Link
                to="/addFacility"
                className=" rounded-full px-3 py-1 bg-primary text-white text-sm font-semibold mt-10 inline-block"
              >
                Add facilities
              </Link>
            </div>
            <ScheduleCard />

            <div
              onClick={() => setUploadmodel(!uploadmodel)}
              htmlFor="dropzone-file"
              className="bg-red-200 p-2 rounded-3xl col-span-3 relative overflow-hidden justify-center text-center cursor-pointer"
            >
              <img
                src="../../../images/labtest.png"
                alt="labtest"
                className="mx-auto h-20"
              />
              <p className="leading-4 text-xs">Lab & Tests</p>

              <input
                id="dropzone-file"
                type="file"
                className="hidden"
                onChange={handleFileChange}
              />
            </div>
            <div
              onClick={() => setUploadmodel(!uploadmodel)}
              className="bg-orange-200 p-2 rounded-3xl col-span-3 relative overflow-hidden justify-center text-center cursor-pointer"
            >
              <img
                src="../../../images/adreport.png"
                className="mx-auto h-20"
                alt="adreport"
              />
              <p className="leading-4 text-xs">Add Report</p>
            </div>

            {/* {!isKiosk && ( 
              // <div className='bg-sky-200 p-4 rounded-3xl col-span-6 relative overflow-hidden'>
              //   <div className='z-10 relative'>
              //     <div className='text-lg font-bold leading-5 mb-2'>Event <br/>Timeline</div>
              //     <p className='leading-4 text-xs'>Review your medical <br/>history using a time-<br/>based visualization</p>
              //     <Link to="/Dashboard"  className=' rounded-full px-3 py-1 bg-primary text-white text-sm font-semibold mt-10 inline-block'>Check all</Link>
              //   </div>

              //   <img src="../../../images/enenttime.png" className=" absolute bottom-0 right-0 z-0"/>
              // </div>
              <></>
             )} */}
          </div>
        </div>
      </div>
      {uploadmodel && filetypes.length>0 && (
        <div className="fixed z-50 bottom-0 pb-20 p-4 pt-7 bg-white w-full rounded-t-3xl shadow-xl">
          <div className="relative flex flex-col ">
            <button
              className="absolute right-0 bg-blue-900 text-white px-1.5 rounded-full transition-all"
              onClick={() => setUploadmodel(!uploadmodel)}
            >
              ✕
            </button>
            <div className="text-lg text-blue-800 pb-3 font-bold">
              Upload Document
            </div>
            <div className="font-bold py-2">Upload Type</div>
            <select
              className="p-2 mb-5 border bg-gray-50 rounded-lg"
              value={filetype}
              onChange={(e) => setfiletype(e.target.value)}
            >
              {filetypes?.map((e, index) => (
                <option key={index} value={e.key}>
                  {e?.value}
                </option>
              ))}
              {/* <option value="pdf">PDF</option>
              <option value="jpg">JPG</option>
              <option value="png">PNG</option> */}
            </select>

            <div className="font-bold py-2">Document Type</div>
            <select
              className="p-2 mb-5 border bg-gray-50 rounded-lg"
              value={doctype}
              onChange={(e) => setDoctype(e.target.value)}
            >
              {documentTypes?.map((e, index) => (
                <option key={index} value={e.key}>
                  {e?.value}
                </option>
              ))}
              {/* <option value="ecg">ECG Report</option>
              <option value="doctor report">Doctor Report</option>
              <option value="pharmacy">Pharmacy Report</option>
              <option value="lab report">Lab Report (Blood Test)</option>
              <option value="other">Other Report</option> */}
            </select>
            <div className="relative p-5 py-7 text-center bg-gray-100">
              {file != null ? (
                <>
                  <div className="text-blue-700">
                    {file.name} <span className=" font-bold">Selected</span>
                  </div>
                  <div className="font-bold">Select another file</div>
                </>
              ) : (
                <>
                  <div>Upload your document here</div>
                  <div className="font-bold">File type PDF,JPG and PNG</div>
                </>
              )}
              <input
                type="file"
                className="absolute top-0 w-full p-7 left-0 opacity-0"
                onChange={(e) => handleFileChange(e)}
              ></input>
            </div>
            <div className="text-center">
              {file != null ? (
                <button
                  className="px-6 py-2 mt-2 rounded-full bg-blue-900 text-white"
                  onClick={() => documentupload()}
                >
                  Upload
                  {fileuploading == "true" && (
                    <Spinner className="ml-2 -mt-1 h-4 w-4 animate-spin inline-block" />
                  )}
                </button>
              ) : (
                <button className="px-6 py-2 mt-2 rounded-full bg-gray-200 text-white">
                  Upload
                </button>
              )}
              {fileuploading == "Select all options" && (
                <div className="text-red-500 font-semibold">
                  Select all options before continuing
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <Tabmenu />
    </>
  );
}
